import { filter } from "rxjs";

export enum FilterOperation {
    equals = 'equals',
    contains = 'contains',
    lessThan = 'lessThan',
    lessOrEqual = 'lessOrEqual',
    greaterThan = 'greaterThan',
    greaterOrEqual = 'greaterOrEqual',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    any = 'any'
}

export interface IFilter {
    toQueryString(): string;
}

export class BaseFilter {
}

export class Filter extends BaseFilter implements IFilter {
    subfilter: Filter|null = null;
    subfilters: Filter[]|null = null;
    operation: FilterOperation = FilterOperation.equals;
    relationship: string = '';
    name: string = '';
    value: any | any[] | null = null;
    allowNull: boolean|Function = () => false;

    constructor(operation: FilterOperation|Filter|Filter[], name: string = '', relationship:string = '', value: any = null, allowNull:boolean|Function = false) {
        super();
        if(operation instanceof Filter) {
            this.subfilter = operation;
        }else if(Array.isArray(operation)) {
            this.subfilters = operation;
        }else{
            this.operation = operation
        }
        this.name = name;
        this.value = value;
        if(typeof allowNull == 'boolean'){
            this.allowNull = () => allowNull;
        }else if(typeof allowNull == 'function'){
            this.allowNull = allowNull;
        }
        this.relationship = relationship;
    }

    public getRelation(): string {
        return this.relationship;
    }

    public isAllowNull(): boolean {
        let ret = false;
        //si es boleano, devolvemos
        if(typeof this.allowNull == 'boolean'){
            ret = this.allowNull;
        }else{
            //si es funcion, la llamamos
            ret = this.allowNull();
        }
        return ret;
    }
    
    public toQueryString(): string {
        let filterValue = null;
        if(this.value != null && this.value !== ''){
            if(Array.isArray(this.value)){
                //un array, hacemos join
                filterValue = this.value.join('\',\'');
            }else{
                if(this.value instanceof Date) {
                    //si es fecha, la convertimos a ISO string
                    filterValue = this.value.toISOString();
                }else{
                    filterValue = this.value;
                }
            }
        }

        //contruimos filtro si tiene valor o permite nulos
        let filter = '';
        if(filterValue!=null || this.isAllowNull()) {
            let filterRelationship = '';
            if(this.relationship!='') filterRelationship = "[" + this.relationship + "]";
            let sValue = filterValue;
            if(sValue != null) sValue = '\'' + filterValue + '\'';
            let operationParams = this.name + ',' + sValue;
            //let filter = "filter"+filterRelationship+"=" + encodeURIComponent(this.operation + '(' + operationParams + ')');
            filter = this.operation + '(' + operationParams + ')';
        }
        return filter;
    }
}

export class NotFilter extends Filter {
    public override toQueryString(): string {
        let sValue = this.value;
        if(this.value != null) sValue = '\'' + sValue + '\'';

        //contruimos filtro si tiene valor o permite nulos
        let filter = '';
        if(sValue!=null || this.isAllowNull()) {
            filter = "not(" + this.operation + '(' + this.name + ',' + sValue + ')' + ")";
        }
        return filter;
    }
}

export class NotHasFilter extends Filter {
    private relation: string;

    constructor(relation: string) {
        super(FilterOperation.equals, '', '', null, false);
        this.relation = relation;
    }

    public override toQueryString(): string {
        if (this.value) {
            return "not(has(" + this.relation + "))";
        }
        return '';
    }
}

export class HasFilter extends BaseFilter implements IFilter {

    relation:string = '';
    filter?:IFilter;

    constructor(relation:string, filter?:IFilter) {
        super();
        this.relation = relation;
        this.filter = filter;
    }
    
    public getRelation(): string {
        return this.relation;
    }

    public toQueryString(): string {
        let hasFilterString = '';
        if(this.filter){
            let filterString = this.filter.toQueryString();
            if(filterString!='') {
                hasFilterString = "has(" + this.relation + "," + filterString + ")";
            }
        }else{
            hasFilterString = "has(" + this.relation + ")";
        }
        return hasFilterString;
    }
}

export class SubsetFilter extends BaseFilter implements IFilter {

    subsetName:string = '';
    filter!:IFilter;

    constructor(subsetName:string, filter:IFilter) {
        super();
        this.subsetName = subsetName;
        this.filter = filter;
    }
    
    public getSubset(): string {
        return this.subsetName;
    }

    public toQueryString(): string {
        return this.filter.toQueryString();
    }
}

export class AndFilter extends BaseFilter implements IFilter {

    public filters: IFilter[]|null = null;

    constructor(filters: IFilter[]) {
        super();
        this.filters = filters;
    }

    public toQueryString(): string {
        let filterString:string[] = [];
        this.filters?.forEach((subfilter: IFilter) => {
            let subfilterQueryString = subfilter.toQueryString();
            if(subfilterQueryString!='') filterString.push(subfilterQueryString);
        });
        let finalFilterString = '';
        if(filterString.length > 1) {
            finalFilterString = 'and(' + filterString.join(",") + ')';
        }else if(filterString.length == 1) {
            finalFilterString = filterString[0];
        }
        return finalFilterString;
    }
}

export class OrFilter extends BaseFilter implements IFilter {

    public filters: IFilter[]|null = null;

    constructor(filters: IFilter[]) {
        super();
        this.filters = filters;
    }

    public toQueryString(): string {
        let filterString:string[] = [];
        this.filters?.forEach((subfilter: IFilter) => {
            let subfilterQueryString = subfilter.toQueryString();
            if(subfilterQueryString!='') filterString.push(subfilterQueryString);
        });
        let finalFilterString = '';
        if(filterString.length > 1) {
            finalFilterString = 'or(' + filterString.join(",") + ')';
        }else if(filterString.length == 1) {
            finalFilterString = filterString[0];
        }
        return finalFilterString;
    }
}

/*export class IncludeFilter extends Filter {

    includeProperty:string = '';

    constructor(includeProperty:string, filter:Filter) {
        super(filter.operation, filter.name, includeProperty, filter.value, filter.allowNull);
        this.includeProperty = includeProperty;
    }

}*/